import { useEffect, useState } from "react";
import { Cpu, Stethoscope, UserRound, Linkedin, Mail } from "lucide-react";
import api, { API } from "@/lib/api";

function placeholder(role = "") {
  if (/tech|cto|engineer|product/i.test(role)) return <Cpu size={40} />;
  if (/doctor|medical|cmo|clinical|health/i.test(role)) return <Stethoscope size={40} />;
  return <UserRound size={40} />;
}

export default function About() {
  const [team, setTeam] = useState([]);
  useEffect(() => { api.get("/public/team").then(r => setTeam(r.data.team || [])).catch(() => {}); }, []);

  return (
    <section className="pgwrap">
      <span className="pg-eyebrow">About us</span>
      <h2 className="pg-h2">Built so a trustworthy second opinion is never out of reach.</h2>
      <p className="pg-lead">2nd Opinion Health Consultants connects patients across India with registered medical specialists for structured second opinions and video consultations. We exist for the moment after a difficult diagnosis — when you need a careful, independent review and a clear explanation before deciding what comes next.</p>

      <h2 className="pg-h2" style={{ fontSize: 26, marginTop: 46 }}>Leadership</h2>
      <div className="lead-grid" data-testid="about-team">
        {team.map((m) => (
          <div className="lead" key={m.id} data-testid={`leader-${m.id}`}>
            <div className="ph" style={m.photo_id ? { padding: 0 } : {}}>
              {m.photo_id
                ? <img src={`${API}/public/image/${m.photo_id}`} alt={m.name} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
                : placeholder(m.role)}
            </div>
            <div className="b">
              <div className="role">{m.role}</div>
              <h4>{m.name}</h4>
              {m.tagline && <div className="lead-tagline" data-testid={`leader-tagline-${m.id}`}>{m.tagline}</div>}
              <p>{m.blurb}</p>
              {(m.linkedin || m.email) && (
                <div className="lead-links">
                  {m.linkedin && <a href={m.linkedin} target="_blank" rel="noreferrer" aria-label={`${m.name} on LinkedIn`} data-testid={`leader-linkedin-${m.id}`}><Linkedin size={16} /></a>}
                  {m.email && <a href={`mailto:${m.email}`} aria-label={`Email ${m.name}`} data-testid={`leader-email-${m.id}`}><Mail size={16} /></a>}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      <p className="pg-lead" style={{ marginTop: 30 }}>We’ll keep developing this page with you — our story, our standards, and the specialists behind the service.</p>
    </section>
  );
}
